// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"878":"844a7ef7","4595":"6bc714f1"}[chunkId] + ".chunk.css";
};